module.exports = __webpack_public_path__ + "img/a011_3.69510e56.png";